import { theme } from '@Guidelines/Theme/theme';
import { uiKitComponentDefaults, uiKitTokens } from '@Guidelines/Theme/uiKitTokens';
import { css, Global } from '@emotion/react';

const globalStyles = css`
	*,
	*::before,
	*::after {
		box-sizing: border-box;
		scrollbar-gutter: unset;
	}

	html {
		scroll-behavior: smooth;
		overflow: hidden;
	}

	body {
		margin: 0;
		min-height: 100vh;
		font-family: ${theme.fonts.body};
		color: ${theme.colors.ink};
		background-color: ${theme.colors.canvas};
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
	}

	h1,
	h2,
	h3,
	p {
		margin: 0;
	}

	a {
		color: ${theme.colors.accent};
		text-decoration: none;
	}

	a:hover {
		color: ${theme.colors.accentDark};
	}

	button {
		font-family: ${theme.fonts.body};
		border: none;
		cursor: pointer;
	}

	::selection {
		background: ${theme.colors.accentBright};
		color: ${theme.colors.ink};
	}

	@media (prefers-reduced-motion: reduce) {
		html {
			scroll-behavior: auto;
		}
	}
`;

/**
 * Reset, page-level canvas and the binding of the kit's role tokens, mounted once at the root of
 * the application. The binding comes first: it only declares variables, the reset consumes them.
 */
const GlobalStyles: React.FC = () => {
	return <Global styles={[uiKitTokens, uiKitComponentDefaults, globalStyles]} />;
};

export default GlobalStyles;
